"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var static_1 = require("@angular/upgrade/static");
var ReplacementContractsComponent = /** @class */ (function (_super) {
    __extends(ReplacementContractsComponent, _super);
    function ReplacementContractsComponent(elementRef, injector) {
        return _super.call(this, 'replacementContracts', elementRef, injector) || this;
    }
    return ReplacementContractsComponent;
}(static_1.UpgradeComponent));
exports.ReplacementContractsComponent = ReplacementContractsComponent;
